export default __webpack_public_path__ + "static/media/stop-small-inactive.9e82e836.svg";